import CeoEventImage from './CeoEventImage';

export default CeoEventImage;
